const maintenanceMessages = {
  post: 'Manutenção Adicionada com Sucesso',
  update: 'Manutenção Atualizada com Sucesso',
  delete: 'Manutenção Deletada com Sucesso',
};

export default maintenanceMessages;